import { isNullish } from '@y42/util/nullish';
import { withTransaction } from './with-transaction';
import { withoutUndoManager } from './without-undo-manager';

let interval: number | undefined;
let initialValues: { [key: string]: unknown } | undefined;
export const withTransactionDebounce = (
  diagram: go.Diagram,
  initialStateCallback: () => { [key: string]: unknown },
  withoutUndoCallback: () => void,
  restoreInitialStateCallback: (initialValues: { [key: string]: unknown }) => void,
  time: number,
  transactionName: string,
) => {
  if (isNullish(interval)) {
    initialValues = initialStateCallback();
  }
  clearTimeout(interval);
  withoutUndoManager(diagram, withoutUndoCallback); // shorten?
  interval = window.setTimeout(() => {
    interval = undefined;
    withoutUndoManager(diagram, () => restoreInitialStateCallback(initialValues || {}));
    withTransaction(diagram, withoutUndoCallback, transactionName);
    initialValues = undefined;
  }, time);
};
